/*
 * @Author: 孙兴隆
 * @description 接口文件
 */
import request from '../../../../api/index'

export default class {
  //删除管理员
  static DeleteAdmin = (params) => {
    return request('post', `employee/delete`, params)
  }
  //重置密码
  static ResetPass = (params) => {
    return request('post', `employee/reset`, params)
  }
  //启/禁用
  static ChangeStatus = (params) => {
    return request('post', `employee/updateState`, params)
  }

  // 启用 / 禁用角色
  static changeRloeStatus = (params) => {
    return request('get', `role/updateState`, params)
  }

  // 删除用户
  static deleteRloe = (params) => {
    return request('get', `role/delete`, params)
  }
}

